module.exports = __webpack_public_path__ + "static/media/day.7f93fbdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/day.svg
// module id = 517
// module chunks = 0